import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  UserPerformance: [],
  UserLeads: [],
  UserActivities: [],
  UserWonLeads: [],
  UserTargets: [],
  GroupPerformance: [],
  Profits: [],
  DailyReport: [],
  SalesReport: [],
  ProductivityScorecard: null,
  SalesPipeline: null,
  TargetScorecard: null,
  ReportFilterOptions: null,
  LossAnalysis: null,
  PipelineVelocity: null,
  LeadTransferAudit: null,

  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status1: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status2: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status3t: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status5: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status4t: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status6: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status7: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status8: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  productivityScorecardStatus: "idle",
  salesPipelineStatus: "idle",
  targetScorecardStatus: "idle",
  reportFilterOptionsStatus: "idle",
  lossAnalysisStatus: "idle",
  pipelineVelocityStatus: "idle",
  leadTransferAuditStatus: "idle",

  error: null,
  IsLogin: true,
};

export const fetchUserPerformance = createAsyncThunk("/Reports/UserPerformanceReport", async date => {
  const response = await axiosInstance.get(
    `/Reports/UserPerformanceReport?from=${date?.from}&to=${date?.to}&groupId=${date?.groupId ? date?.groupId : ""}`
  );
  return response.data;
});
export const fetchUserLeads = createAsyncThunk("/Reports/UserLeadReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/UserLeadReport?from=${data?.from}&to=${data?.to}&leadSourceId=${data?.leadSourceId}&userId=${data?.userId}`
  );
  return response.data;
});
export const fetchUserActivities = createAsyncThunk("/Reports/UserActivityReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/UserActivityReport?from=${data?.from}&to=${data?.to}&activityType=${data?.type}&userId=${data?.userId}`
  );
  return response.data;
});
export const fetchUserWonLeads = createAsyncThunk("/Reports/WonLeadPaymentReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/WonLeadPaymentReport?from=${data?.from}&to=${data?.to}&userId=${data?.userId}`
  );
  return response.data;
});
export const fetchUserTargets = createAsyncThunk("/Reports/UserTargetReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/UserTargetReport?userId=${data?.userId}&projectId=${data?.projectId}`
  );
  return response.data;
});
export const fetchGroupPerformance = createAsyncThunk("/Reports/GroupPerformanceReport", async () => {
  const response = await axiosInstance.get(`/Reports/GroupPerformanceReport`);
  return response.data;
});
//////////
export const fetchsalesreport = createAsyncThunk("Reports/SaleReport", async date => {
  const response = await axiosInstance.get(`/Reports/SaleReport?from=${date?.from}&to=${date?.to}`);
  return response.data;
});

export const fetchProfits = createAsyncThunk("/Reports/ProfitReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/ProfitReport?userId=${data?.userId}&projectId=${data?.projectId}&from=${data?.from}&to=${data?.to}`
  );
  return response.data;
});

export const fetchDailyReport = createAsyncThunk("/Reports/TotalActivitiesReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/TotalActivitiesReport?date=${data?.date}&projectId=${data?.projectId}`
  );
  return response.data;
});

export const fetchProductivityScorecard = createAsyncThunk("/Reports/productivity-scorecard", async (data) => {
  const response = await axiosInstance.post("/Reports/productivity-scorecard", data);
  return response.data;
});

export const fetchSalesPipeline = createAsyncThunk("/Reports/sales-pipeline", async (data) => {
  const response = await axiosInstance.post("/Reports/sales-pipeline", data);
  return response.data;
});

export const fetchTargetScorecard = createAsyncThunk("/Reports/target-scorecard", async (data) => {
  const response = await axiosInstance.post("/Reports/target-scorecard", data);
  return response.data;
});

export const fetchReportFilterOptions = createAsyncThunk("/Reports/filter-options", async () => {
  const response = await axiosInstance.get("/Reports/filter-options");
  return response.data;
});

export const fetchLossAnalysis = createAsyncThunk("/Reports/loss-analysis", async (data) => {
  const response = await axiosInstance.post("/Reports/loss-analysis", data);
  return response.data;
});

export const fetchPipelineVelocity = createAsyncThunk("/Reports/pipeline-velocity", async (data) => {
  const response = await axiosInstance.post("/Reports/pipeline-velocity", data);
  return response.data;
});

export const fetchLeadTransferAudit = createAsyncThunk("/Reports/lead-transfer-audit", async (data) => {
  const response = await axiosInstance.post("/Reports/lead-transfer-audit", data);
  return response.data;
});
const ReportSlice = createSlice({
  name: "Reports",
  initialState,
  reducers: {
    ReportsAdded: {
      reducer(state, action) {
        state.UserPerformance?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchUserPerformance.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUserPerformance.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserPerformance = action.payload.Data;
      })
      .addCase(fetchUserPerformance.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchUserLeads.pending, state => {
        state.status1 = "loading";
      })
      .addCase(fetchUserLeads.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserLeads = action.payload.Data;
      })
      .addCase(fetchUserLeads.rejected, (state, action) => {
        state.error = action.error.message;
        state.status1 = "failed";
      })
      .addCase(fetchUserActivities.pending, state => {
        state.status2 = "loading";
      })
      .addCase(fetchUserActivities.fulfilled, (state, action) => {
        state.status2 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserActivities = action.payload.Data;
      })
      .addCase(fetchUserActivities.rejected, (state, action) => {
        state.error = action.error.message;
        state.status2 = "failed";
      })
      .addCase(fetchUserWonLeads.pending, state => {
        state.status3t = "loading";
      })
      .addCase(fetchUserWonLeads.fulfilled, (state, action) => {
        state.status3t = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserWonLeads = action.payload.Data;
      })
      .addCase(fetchUserWonLeads.rejected, (state, action) => {
        state.error = action.error.message;
        state.status3t = "failed";
      })
      .addCase(fetchUserTargets.pending, state => {
        state.status4t = "loading";
      })
      .addCase(fetchUserTargets.fulfilled, (state, action) => {
        state.status4t = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserTargets = action.payload.Data;
      })
      .addCase(fetchUserTargets.rejected, (state, action) => {
        state.error = action.error.message;
        state.status4t = "failed";
      })
      .addCase(fetchGroupPerformance.pending, state => {
        state.status5 = "loading";
      })
      .addCase(fetchGroupPerformance.fulfilled, (state, action) => {
        state.status5 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.GroupPerformance = action.payload.Data;
      })
      .addCase(fetchGroupPerformance.rejected, (state, action) => {
        state.error = action.error.message;
        state.status5 = "failed";
      })
      /////////
      .addCase(fetchsalesreport.pending, state => {
        state.status7 = "loading";
      })
      .addCase(fetchsalesreport.fulfilled, (state, action) => {
        state.status7 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;

        state.SalesReport = action.payload.Data;
      })
      .addCase(fetchsalesreport.rejected, (state, action) => {
        state.error = action.error.message;
        state.status7 = "failed";
      })
      /////

      .addCase(fetchProfits.pending, state => {
        state.status6 = "loading";
      })
      .addCase(fetchProfits.fulfilled, (state, action) => {
        state.status6 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Profits = action.payload.Data;
      })
      .addCase(fetchProfits.rejected, (state, action) => {
        state.error = action.error.message;
        state.status6 = "failed";
      })
      .addCase(fetchDailyReport.pending, state => {
        state.status8 = "loading";
      })
      .addCase(fetchDailyReport.fulfilled, (state, action) => {        
        state.status8 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.DailyReport = action.payload.Data;
      })
      .addCase(fetchDailyReport.rejected, (state, action) => {
        state.error = action.error.message;
        state.status8 = "failed";
      })
      .addCase(fetchProductivityScorecard.pending, state => {
        state.productivityScorecardStatus = "loading";
      })
      .addCase(fetchProductivityScorecard.fulfilled, (state, action) => {        
        state.productivityScorecardStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.ProductivityScorecard = action.payload.Data;
      })
      .addCase(fetchProductivityScorecard.rejected, (state, action) => {
        state.error = action.error.message;
        state.productivityScorecardStatus = "failed";
      })
      .addCase(fetchSalesPipeline.pending, state => {
        state.salesPipelineStatus = "loading";
      })
      .addCase(fetchSalesPipeline.fulfilled, (state, action) => {        
        state.salesPipelineStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.SalesPipeline = action.payload.Data;
      })
      .addCase(fetchSalesPipeline.rejected, (state, action) => {
        state.error = action.error.message;
        state.salesPipelineStatus = "failed";
      })
      .addCase(fetchTargetScorecard.pending, state => {
        state.targetScorecardStatus = "loading";
      })
      .addCase(fetchTargetScorecard.fulfilled, (state, action) => {        
        state.targetScorecardStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.TargetScorecard = action.payload.Data;
      })
      .addCase(fetchTargetScorecard.rejected, (state, action) => {
        state.error = action.error.message;
        state.targetScorecardStatus = "failed";
      })
      .addCase(fetchReportFilterOptions.pending, state => {
        state.reportFilterOptionsStatus = "loading";
      })
      .addCase(fetchReportFilterOptions.fulfilled, (state, action) => {
        state.reportFilterOptionsStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.ReportFilterOptions = action.payload.Data;
      })
      .addCase(fetchReportFilterOptions.rejected, (state, action) => {
        state.error = action.error.message;
        state.reportFilterOptionsStatus = "failed";
      })
      .addCase(fetchLossAnalysis.pending, state => {
        state.lossAnalysisStatus = "loading";
      })
      .addCase(fetchLossAnalysis.fulfilled, (state, action) => {
        state.lossAnalysisStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LossAnalysis = action.payload.Data;
      })
      .addCase(fetchLossAnalysis.rejected, (state, action) => {
        state.error = action.error.message;
        state.lossAnalysisStatus = "failed";
      })
      .addCase(fetchPipelineVelocity.pending, state => {
        state.pipelineVelocityStatus = "loading";
      })
      .addCase(fetchPipelineVelocity.fulfilled, (state, action) => {
        state.pipelineVelocityStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.PipelineVelocity = action.payload.Data;
      })
      .addCase(fetchPipelineVelocity.rejected, (state, action) => {
        state.error = action.error.message;
        state.pipelineVelocityStatus = "failed";
      })
      .addCase(fetchLeadTransferAudit.pending, state => {
        state.leadTransferAuditStatus = "loading";
      })
      .addCase(fetchLeadTransferAudit.fulfilled, (state, action) => {
        state.leadTransferAuditStatus = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadTransferAudit = action.payload.Data;
      })
      .addCase(fetchLeadTransferAudit.rejected, (state, action) => {
        state.error = action.error.message;
        state.leadTransferAuditStatus = "failed";
      });
  },
});

export const getReportsDetails = state => state.Reports;

export const { ReportsAdded } = ReportSlice.actions;

export default ReportSlice.reducer;
